/**
 * The Symagic Server Task entity
 * @author Tom Verschoore de la Houssaije
 */
import { BreezeService } from '../../core/breeze.service';
import * as moment from 'moment';
/**
 * The Symagic Server Task entity
 */
var Task = /** @class */ (function () {
    function Task() {
        /**
         * Holding reference to task
         * @private
         * @type {Entity}
         */
        this.project = undefined;
        /**
         * Holding Reference of task
         * @private
         * @type {Entity}
         */
        this.shift = undefined;
        /**
         * The sum of efforts of all the underlying assignment
         * @type {moment.Duration}
         */
        this.planned = undefined;
        /**
         * The sum of efforts of all the underlying deployments, or the direct property, whichever is higher
         * @type {moment.Duration}
         */
        this.effort = undefined;
    }
    Object.defineProperty(Task.prototype, "Planned", {
        /**
         * Gets the ISO string of the Planned duration property
         * @type {string}
         */
        get: function () {
            if (!this.planned) {
                return undefined;
            }
            return this.planned.toISOString();
        },
        /**
         * Sets the Planned duration property from its ISO string representation
         */
        set: function (value) {
            this.planned = moment.duration(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "Effort", {
        /**
         * Gets the ISO string of the Effort duration property
         * @type {string}
         */
        get: function () {
            if (!this.effort) {
                return undefined;
            }
            return this.effort.toISOString();
        },
        /**
         * Sets the Effort duration property from its ISO string representation
         */
        set: function (value) {
            this.effort = moment.duration(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "Project", {
        /**
         * Gets the project of the task
         * @readonly
         * @type {Entity}
         */
        get: function () {
            // This is needed to override breeze.js navigation property
            if (!this.project && this.entityAspect && this.entityAspect.entityState.isDetached()) {
                return undefined;
            }
            return this.project;
        },
        /**
         * Sets the project of the task
         */
        set: function (value) {
            if (value && value !== this.project && this.entityAspect.entityState.isAdded()) {
                this.Start = value['Start'];
                this.Finish = value['Finish'];
                this.Name = value['Name'];
                this.Color = value['Color'];
                // Issue #2579
                if (this.Department_Oid === '') {
                    this.Department_Oid = value['Department_Oid'];
                    if (this.Department_Oid !== '' && this['Department'] == null) {
                        this.entityAspect.loadNavigationProperty('Department');
                    }
                }
                // Deze kan weg wanneer #2150 afgerond is.
                // this.Notes = value['Notes'];
            }
            this.project = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "Shift", {
        /**
         * Gets the shift of the task.
         * @readonly
         * @type {Entity}
         */
        get: function () {
            // This is needed to override breeze.js navigation property.
            if (!this.shift && this.entityAspect && this.entityAspect.entityState.isDetached()) {
                return undefined;
            }
            return this.shift;
        },
        /**
         * Sets the shift of the task
         */
        set: function (value) {
            if (value && value !== this.shift && this.entityAspect.entityState.isAdded()) {
                this.Start = value['Start'];
                this.Finish = value['Finish'];
            }
            this.shift = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Copies the task into a new task or task template
     * @param newStart The date to which Start is shifted
     * @param include A string containing which entities, space separated, should be included in the copy
     * @param template Indicates whether the task should be copied into a template
     * @param afterSave Indicates whether the method is invoked after properties changes are committed or before
     */
    Task.prototype.copy = function (newStart, include, template, afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        return BreezeService.invokeMethod(this, 'Copy', [newStart, include, template], afterSave);
    };
    /**
     * Removes Taskneed instance from this object with taking into account situations of inherited collections.
     * @param {string} taskNeed The Oid of the Taskneed to remove.
     * @param {boolean} [afterSave=false] Indicates whether the method is invoked after properties changes are committed or before
     * @memberOf Task
     */
    Task.prototype.removeNeed = function (taskNeed, afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        return BreezeService.invokeMethod(this, 'RemoveNeed', [taskNeed], afterSave);
    };
    /**
     * Returns whether task has been fully planned
     * @returns {boolean} A value indicating whether Planned is greater than or equal to Effort
     */
    Task.prototype.isFullyPlanned = function () {
        var planned = this.planned.asHours();
        var budget = moment.duration(this['EffortBudget']).asHours();
        return planned >= budget;
    };
    return Task;
}());
export { Task };
